import { useEffect, useState } from 'react';
import { Warning } from './Warning';
import { logout, useApp, verifyPin } from '../store';
import { Loader } from './Loader';
import { useTranslation } from 'react-i18next';
import { OTPInput, REGEXP_ONLY_DIGITS } from 'input-otp';

export function VerifyPin() {
  const { t } = useTranslation();
  const { state, dispatch } = useApp();
  const [warning, setWarning] = useState<string[]>([]);
  const [pin, setPin] = useState('');

  useEffect(() => {
    if (state.pinRetries === 0) {
      setWarning([]);
      logout(dispatch);
    }

    if (state.pinRetries) {
      setWarning([t('warningPinWrong')]);
    }
  }, [state.pinRetries, dispatch, t]);

  // WebOTP API - automatically read OTP from SMS
  useEffect(() => {
    if ('OTPCredential' in window) {
      const abortController = new AbortController();

      navigator.credentials
        .get({
          otp: { transport: ['sms'] },
          signal: abortController.signal,
        } as any)
        .then((otp: any) => {
          if (otp && otp.code) {
            console.log('WebOTP code received:', otp.code);
            setPin(otp.code);
            handlePin(otp.code);
            setTimeout(() => setPin(''), 100);
          }
        })
        .catch((err) => {
          console.log('WebOTP error:', err);
        });

      return () => {
        abortController.abort();
      };
    }
  }, []);

  const handlePin = (pinValue: string) => {
    if (pinValue !== '') {
      verifyPin( pinValue , dispatch);
    }
  };

  const handleLogout = () => {
    logout(dispatch);
  };

  if (!state.hasVerifiedPasscode || !state.isLoggedIn) {
    return null;
  }

  if (state.hasVerifiedPin) {
    return null;
  }

  if (state.loading) {
    return <Loader />;
  }

  return (
    <>
      <div className="logout_menu">
        <button className="logout" onClick={handleLogout}>
          &#10005;
        </button>
      </div>
      <Warning message={warning} />
      <p>{t('smsText')}</p>
      <OTPInput
        maxLength={4}
        value={pin}
        onChange={(value) => {
          setPin(value);
          setWarning([]);

          // Auto-submit når 4 siffer er fylt
          if (value.length === 4) {
            handlePin(value);
            setTimeout(() => setPin(''), 100);
          }
        }}
        pattern={REGEXP_ONLY_DIGITS}
        containerClassName=""
        autoFocus
        pushPasswordManagerStrategy="none"
        data-1p-ignore="true"
        data-bwignore="true"
        data-lpignore="true"
        data-form-type="other"
        render={({ slots }) => (
          <div style={{ display: 'flex', gap: '10px', marginTop: '5px' }}>
            {slots.map((slot, idx) => (
              <div
                key={idx}
                style={{
                  width: '50px',
                  height: '50px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '24px',
                  border: '2px solid gray',
                  borderRadius: '10px',
                  backgroundColor: 'white',
                  color: 'black',
                  position: 'relative',
                }}
              >
                {slot.char || (slot.hasFakeCaret && (
                  <div style={{
                    width: '2px',
                    height: '24px',
                    backgroundColor: 'black',
                    animation: 'blink 1s infinite',
                  }} />
                ))}
              </div>
            ))}
          </div>
        )}
      />
    </>
  );
}
